import { createApiClient, createTaktApi } from "@takt/api-client"
import { buildSignInUrl } from "./auth"
import { config } from "./config"

let redirectingToIdentity = false

const client = createApiClient({
    baseUrl: config.apiBaseUrl,
    getCredentials: () => "include",
    onUnauthorized: () => {
        if (redirectingToIdentity || typeof window === "undefined") return
        redirectingToIdentity = true
        const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`
        window.location.assign(buildSignInUrl(returnTo))
    },
})

export const api = createTaktApi(client)
